import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface PartnerFileInventoryFailureProps extends BaseTemplateProps {
  filename: string
  locationCodes: string
}

export const PartnerFileInventoryFailureNotification: TemplateDefinition<PartnerFileInventoryFailureProps> =
  {
    renderParams: (props: PartnerFileInventoryFailureProps) => ({
      messageKey: 'notificationsDomain.templates.partnerFileInventoryFailureNotification',
      values: {
        filename: props.filename,
        locationCodes: props.locationCodes,
      },
    }),
  }
